export default class SplitFeature {

	static selector = 'split-feature';

	el = {};

	isClicked = false;

	constructor(container) {
		this.el = {
			container,
			controls: container.querySelectorAll('[data-gl-control]'),
			controlsContainer: container.querySelector(`.${this.constructor.selector}__controls`),
			slides: container.querySelectorAll(`.${this.constructor.selector}__slide`),
			slidesContainer: container.querySelector(`.${this.constructor.selector}__container`),
		};

		this.addEventListeners();
	}

	addEventListeners() {
		for (const control of this.el.controls) {
			control.addEventListener('click', this.#onControlClick);
		}
	}

	removeEventListeners() {
		for (const control of this.el.controls) {
			control.removeEventListener('click', this.#onControlClick);
		}
	}

	#onControlClick = (e) => {
		const { currentTarget } = e;
		const index = [...this.el.controls].indexOf(currentTarget);
		const wasActive = this.el.controlsContainer.querySelector('.is-active');
		const wasActiveSlide = this.el.slidesContainer.querySelector('.is-active');
		const event = new CustomEvent('splitFeature:click', { detail: index });

		this.el.container.dispatchEvent(event);

		if (wasActive && wasActiveSlide) {
			wasActive.classList.remove('is-active');
			wasActiveSlide.classList.remove('is-active');
		}

		if (!this.isClicked) {
			this.isClicked = true;
			this.el.container.classList.add('is-clicked');
		}

		if (!currentTarget.classList.contains('is-active')) {
			currentTarget.classList.add('is-active');
			this.el.slides[index].classList.add('is-active');
		}
	}

	destroy() {
		this.removeEventListeners();
	}

}
